const conf={
    appwriteUrl:String(process.env.REACT_APP_APPWRITE_URL),
    collectionId: String(process.env.REACT_APP_APPWRITE_COLLECTION_ID),
    projectId: String(process.env.REACT_APP_APPWRITE_PROJECT_ID),
    databaseId:String(process.env.REACT_APP_APPWRITE_DATABASE_ID),
    bucketId: String(process.env.REACT_APP_APPWRITE_BUCKET_ID),


}

export default conf